import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ElhandelLista = lazy(() => import("@/pages/content/ElhandelLista"));

export const Route = createFileRoute("/elhandel/")({
  head: () => seoHead("/elhandel", { description: "Utforska Sveriges elhandelsbolag – jämför avtal, priser och villkor hos varje leverantör." }),
  component: () => <ElhandelLista />,
});
